import { Injectable, signal } from '@angular/core';
import { IAlerta } from '@models/IAlerta';

@Injectable({
  providedIn: 'root',
})
export class AlertasService {
  alertas = signal<IAlerta[]>([]);

  /**
 * duration:
 *   - > 0  => se cierra automáticamente después de `duration` ms
 *   - 0   => no se cierra automáticamente (requiere clic en cerrar)
 */
  showAlert(
    type: 'success' | 'error' | 'warning' | 'info' | '',
    title: string,
    message: string,
    duration: number = 3500,
  ) {
    let id = crypto.randomUUID();
    const nuevaAlerta: IAlerta = {
      id,
      show: true,
      type,
      title,
      message,
    };
    this.alertas.set([...this.alertas(), nuevaAlerta]);

    if (duration != 0) {
      setTimeout(() => this.startFadeOut(id), duration);
    }
  }

  startFadeOut(id: string) {
    document
      .querySelector(`.alert[data-id="${id}"]`)
      ?.classList.add('fade-out');

    setTimeout(() => this.removeAlert(id), 500);
  }

  removeAlert(id: string | undefined) {
    this.alertas.set(this.alertas().filter((alerta) => alerta.id !== id));
  }
}
